module.exports = {
	"id": "MZ",
	"name": "Mozambique",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": 0.001373,
			"11": 0.01373,
			"12": null,
			"13": 0.004119,
			"14": null,
			"15": 0.002746,
			"16": 0.002746,
			"17": null,
			"18": null,
			"19": 0.002746,
			"20": 0.001373,
			"21": 0.005492,
			"22": null,
			"23": 0.002746,
			"24": null,
			"25": 0.005492,
			"26": 0.012357,
			"27": null,
			"28": 0.004119,
			"29": 0.005492,
			"30": 0.005492,
			"31": 0.005492,
			"32": 0.002746,
			"33": 0.021968,
			"34": 0.005492,
			"35": 0.001373,
			"36": 0.020595,
			"37": 0.002746,
			"38": 0.004119,
			"39": 0.006865,
			"40": 0.038444,
			"41": 0.002746,
			"42": 0.010984,
			"43": 0.56293,
			"44": 0.008238,
			"45": 0.039817,
			"46": 0.010984,
			"47": 0.032952,
			"48": 0.010984,
			"49": 0.196339,
			"50": 0.035698,
			"51": 0.183982,
			"52": 0.116705,
			"53": 3.907558,
			"54": 0.930894,
			"55": 0.015103,
			"56": 0.002746,
			"57": null
		},
		"firefox": {
			"2": 0.001373,
			"3": 0.009611,
			"4": 0.005492,
			"5": 0.002746,
			"6": 0.002746,
			"7": 0.004119,
			"8": 0.004119,
			"9": 0.002746,
			"10": 0.008238,
			"11": 0.019222,
			"12": 0.012357,
			"13": 0.017849,
			"14": 0.008238,
			"15": 0.008238,
			"16": 0.009611,
			"17": 0.006865,
			"18": 0.004119,
			"19": 0.006865,
			"20": 0.019222,
			"21": 0.005492,
			"22": 0.005492,
			"23": 0.002746,
			"24": 0.006865,
			"25": 0.005492,
			"26": 0.002746,
			"27": 0.001373,
			"28": 0.002746,
			"29": 0.006865,
			"30": 0.016476,
			"31": 0.008238,
			"32": 0.006865,
			"33": 0.015103,
			"34": 0.005492,
			"35": 0.015103,
			"36": 0.009611,
			"37": 0.01373,
			"38": 0.012357,
			"39": 0.015103,
			"40": 0.015103,
			"41": 0.01373,
			"42": 0.01373,
			"43": 0.108467,
			"44": 0.032952,
			"45": 0.030206,
			"46": 0.034325,
			"47": 0.199085,
			"48": 0.196339,
			"49": 1.434785,
			"50": 0.079634,
			"51": null,
			"52": null,
			"3.5": 0.004119,
			"3.6": 0.010984
		},
		"opera": {
			"9": null,
			"11": 0.005492,
			"12": 0.004119,
			"15": 0.002746,
			"16": 0.004119,
			"17": 0.002746,
			"18": 0.001373,
			"19": null,
			"20": 0.006865,
			"21": 0.002746,
			"22": 0.004119,
			"23": null,
			"24": 0.002746,
			"25": null,
			"26": 0.001373,
			"27": null,
			"28": 0.001373,
			"29": 0.004119,
			"30": 0.008238,
			"31": null,
			"32": 0.005492,
			"33": 0.015103,
			"34": 0.020595,
			"35": 0.021968,
			"36": 0.02746,
			"37": 0.266362,
			"38": 0.019222,
			"39": 0.043936,
			"40": 0.374829,
			"41": 0.038444,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": 0.005492,
			"11.1": 0.001373,
			"11.5": 0.006865,
			"11.6": 0.012357,
			"12.1": 0.012357
		},
		"safari": {
			"0": null,
			"4": 0,
			"5": 0.004119,
			"6": 0.009611,
			"7": 0.002746,
			"8": 0.024714,
			"9": 0.017849,
			"10": 0.076888,
			"3.1": null,
			"3.2": null,
			"5.1": 0.012357,
			"6.1": 0.015103,
			"7.1": 0.012357,
			"9.1": 0.085126
		},
		"ios_saf": {
			"8": 0,
			"10": 0.601533916736,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.0162106430058,
			"8.1-8.4": 0.0299484760616,
			"9.0-9.2": 0.014287346378,
			"9.3": 0.217973617818
		},
		"android": {
			"3": 0,
			"4": 0.0555516382429,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00694395478036,
			"4.1": 0.20038269509,
			"4.2-4.3": 0.500956737726,
			"4.4": 1.14872851938,
			"4.4.3-4.4.4": 1.15864845478
		},
		"ie": {
			"6": 0.00275410627306,
			"7": 0.00550821254613,
			"8": 0.362164974908,
			"9": 0.155607004428,
			"10": 0.121180676015,
			"11": 1.21869202583,
			"5.5": null
		},
		"op_mob": {
			"0": 4.59472733836,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.127631314954
		},
		"edge": {
			"12": 0.081007,
			"13": 0.130435,
			"14": 0.10984
		},
		"ie_mob": {
			"10": 0.231349408451,
			"11": 0.941922591549
		},
		"bb": {
			"7": 0.10136725,
			"10": null
		},
		"samsung": {
			"0": 1.173272
		},
		"and_uc": {
			"0": 3.821761
		},
		"op_mini": {
			"0": 61.9039623467
		},
		"and_chr": {
			"0": 7.927529
		},
		"and_ff": {
			"0": null
		}
	},
	"total": 96.88042925
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/MZ.json
 ** module id = 603
 ** module chunks = 0
 **/